import { IONICWrapper } from "../common";
import { Roles } from "../constants";

/**
 * @param void
 * isDispatcherRole method, identifies whether the user role has Dispatcher,
 * isAdminRole method, identifies whether the user role has Admin, 
 * isLeasedOwnerOprRole method, identifies whether the user role has Leased On Owner Operator,
 * isLeasedOwnerOprRoleOnly method, identifies whether the user role is Leased On Owner Operator only,
 * isAdminRoleOnly method, identifies whether the user role is Admin only
 * @returns Boolean
 */

 export const isDispatcherRole = () => {
    return IONICWrapper?.details?.auth?.user?.roles?.includes(Roles.carrierDispatcher);
  };
 export const isDriverRoleOnly = () => {
    return IONICWrapper?.details?.auth?.user?.roles?.includes(Roles.carrierDriver);
  };
  export const isAdminRole = () => {
    return IONICWrapper?.details?.auth?.user?.roles?.includes(Roles.carrierAdmin);
  };
  export const  isAdminRoleOnly = () => {
    return IONICWrapper?.details?.auth?.user?.roles && IONICWrapper.details.auth.user.roles?.length === 1 && IONICWrapper.details.auth.user.roles[0] === Roles.carrierAdmin;
  };
  export const isLeasedOwnerOprRole = () => {
    return IONICWrapper?.details?.auth?.user?.roles?.includes(Roles.carrierLeasedOwnerOpr);
  };
  export const  isLeasedOwnerOprRoleOnly = () => {
    return IONICWrapper?.details?.auth?.user?.roles && IONICWrapper.details.auth.user.roles?.length === 1 && IONICWrapper.details.auth.user.roles[0] === Roles.carrierLeasedOwnerOpr;
  };
  export const isDispatcherRoleOnly = () => {
    return IONICWrapper?.details?.auth?.user?.roles && IONICWrapper.details.auth.user.roles?.length === 1 && IONICWrapper.details.auth.user.roles[0] === Roles.carrierDispatcher;
  };
  export const isElevatedLeasedOwenerOprRole = () =>{
    return isLeasedOwnerOprRole() && !isDispatcherRole();
  };
  export const  isLeasedOwnerOprRoleOnlyOnSelectedUser = (roles : any) => {
    return roles?.length === 1 && roles[0] === Roles.carrierLeasedOwnerOpr;
  };
  export const isElevatedLeasedOwenerOprRoleOnSelectedUser = (roles : any) =>{
    return isLeasedOwnerOprRoleOnSelectedUser(roles) && !isDispatcherRoleOnSelectedUser(roles);
  };
  export const isLeasedOwnerOprRoleOnSelectedUser = (roles : any) => {
    return roles?.includes(Roles.carrierLeasedOwnerOpr);
  };
  export const isDispatcherRoleOnSelectedUser = (roles : any) => {
    return roles?.includes(Roles.carrierDispatcher);
  };
  export const  isLeasedOwnerOprRoleOnlyOnRestricteduser = (roles : any) => {
    return roles?.length === 1 && roles[0].value === Roles.carrierLeasedOwnerOpr;
  };
  export const isNotALeasedOwnerOprRoleOnRestricteduser = (roles : any) => {
    return !roles?.includes(Roles.carrierLeasedOwnerOpr);
  };
  